var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDisabledClaim(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 86 85.8",
    enableBackground: "new 0 0 86 85.8",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Claim",
    transform: "translate(-2 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    fill: "#BABDBF",
    d: "M78,25.8h-2v-1.9c0-5.5-4.5-10-10-10h-2V12c0-5.5-4.5-10-10-10H12C6.5,2,2,6.5,2,12v42 c0,5.5,4.5,10,10,10h2v1.9c0,5.5,4.5,10,10,10h2v1.9c0,5.5,4.5,10,10,10h42c5.5,0,10-4.5,10-10v-42C88,30.3,83.5,25.8,78,25.8z  M34.1,35.9c0-1,0.8-1.9,1.8-1.9c0,0,0.1,0,0.1,0h42c1,0,1.9,0.8,1.9,1.8c0,0,0,0.1,0,0.1v42c0,1-0.8,1.9-1.8,1.9c0,0-0.1,0-0.1,0 H36c-1,0-1.9-0.8-1.9-1.8c0,0,0-0.1,0-0.1V35.9z M22.1,23.9c0-1,0.8-1.9,1.8-1.9c0,0,0.1,0,0.1,0h42c1,0,1.9,0.8,1.9,1.8 c0,0,0,0.1,0,0.1v1.9H36c-5.5,0-10,4.5-10,10v31.9h-2c-1,0-1.9-0.8-1.9-1.8c0,0,0-0.1,0-0.1L22.1,23.9z M24,13.8 c-5.5,0-10,4.5-10,10v31.9h-2c-1,0-1.9-0.8-1.9-1.8c0,0,0-0.1,0-0.1v-42c0-1,0.8-1.9,1.8-1.9c0,0,0.1,0,0.1,0h42 c1,0,1.9,0.8,1.9,1.8c0,0,0,0.1,0,0.1v1.9H24V13.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    fill: "#BABDBF",
    d: "M44.9,61.4h8.8v8.5c0,1.7,1.4,3.1,3.2,3.1c1.8,0,3.2-1.4,3.2-3.1v-8.5h8.9 c1.8,0,3.2-1.4,3.2-3.1s-1.4-3.1-3.2-3.1h-8.9v-8.6c0-1.7-1.4-3.1-3.2-3.1s-3.2,1.4-3.2,3.1v8.5h-8.9c-1.8,0-3.2,1.4-3.2,3.1 C41.6,59.9,43,61.4,44.9,61.4C44.9,61.4,44.9,61.4,44.9,61.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#59B4C9",
    d: "M71.6,69c-0.7-0.6-1.7-0.6-2.4,0c-6.5,7-17.7,7-24.8,0.3 c-7.3-6.8-7.9-17.9-1.4-24.8c6.1-6.6,16.3-7.1,23.5-1.5l-2.6,2.8c-0.4,0.4-0.5,1.1-0.2,1.6c0,0.3,0.2,0.5,0.5,0.8 c0.2,0.2,0.3,0.3,0.7,0.4L76,51.4c0.7,0.3,1.3,0,1.6-0.4c0.4-0.4,0.7-1.1,0.3-1.7l-3.5-10.9c-0.1-0.3-0.2-0.6-0.4-0.7l-0.1-0.1 c-0.2-0.2-0.5-0.3-0.8-0.3c-0.5-0.2-1.2,0-1.7,0.4l-2.7,2.9c-8.6-6.8-21-6.3-28.4,1.6c-7.8,8.3-7.1,21.6,1.6,29.7 c8.6,8,21.9,7.8,29.6-0.5C72.3,70.7,72.3,69.7,71.6,69L71.6,69z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisabledClaim);
export default __webpack_public_path__ + "static/media/disabledClaim.5f367c0083fa3aab7c292810e32df59b.svg";
export { ForwardRef as ReactComponent };